export function listItemSoftLineBreaksTransformer(dataSeries) {
    return dataSeries.map((series) => (Object.assign(Object.assign({}, series), { data: series.data.map((point) => (Object.assign(Object.assign({}, point), { item: typeof point.item === "string" ? point.item.replace(/\//g, "\u200B/") : point.item }))) })));
}
